import { render, staticRenderFns } from "./NewsCategoryTable.vue?vue&type=template&id=64bdff50&"
import script from "./NewsCategoryTable.vue?vue&type=script&lang=js&"
export * from "./NewsCategoryTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports